import baseTree from '@/components/mixins/baseTree'
import { mapActions, mapGetters } from 'vuex'
export default {
  mixins: [baseTree],
  props: {
    noNav: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('interact', ['collectTaskTree'])
  },
  methods: {
    ...mapActions('interact', ['FetchCollectTaskList']),
    handleClick (data) {
      if (this.noNav) {
        this.$emit('click', data)
        return
      }
      this.$router.push({
        name: 'interactCollectDetail',
        query: { id: data.id }
      })
    },
    setCurrentNodeKey (id) {
      this.tree.currentNodeKey = id
    }
  },
  mounted () {
    this.FetchCollectTaskList()
  }
}
